import React, {useEffect, useState} from 'react';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import {Col, Row, Container, Tooltip, OverlayTrigger} from "react-bootstrap";
import {MdSend, MdCreate} from "react-icons/md";
import {getMessages, hideRecipient} from "../../../services/notifications";
import {useHistory} from "react-router-dom";
import {MdDelete} from "react-icons/all";
import ScaleLoader from "react-spinners/ScaleLoader";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import Notification from '../../../components/Notification/Notification';

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const NotificationList = (props) => {
   const [notifications, setNotifications] = useState([]);
   const [selectedNotifications, setselectedNotifications] = useState([])
   const [loading, setLoading] = useState(true);
   const history = useHistory();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         try {
            let notifications = await getMessages();
            setNotifications(notifications);
            setLoading(false);
         } catch (e) {
            NotificationManager.error(t("inbox_page.errors.fetching_failed"), t("common.error"), 4000);
            setLoading(false);
         }
      })()
   }, []);

   return <div className={"NotificationList"}>
      <Header headerBarTitle={t("inbox_page.header")} headerButtonRight="" showHeaderExtras/>

      <Container className={"desktop"}>
         <Row>
            <Col xs={12}>
               <div className="alert alert-info" role="alert">
                  {t("inbox_page.notice")}
               </div>

               <ScaleLoader
                   css={override}
                   sizeUnit={"px"}
                   size={30}
                   color={'#afff55'}
                   loading={loading}
               />

               {!loading && notifications.length === 0 &&
                   <div className="alert alert-info" role="alert">
                      {t("inbox_page.empty")}
                   </div>
               }

            </Col>
         </Row>

         <Row className={"justify-content-end"}>
            <Col xs={12} className={"pb-3 text-right"}>
               {selectedNotifications.length !== 0 &&
                   <OverlayTrigger
                       placement={'bottom'}
                       delay={{show: 250, hide: 400}}
                       overlay={
                          <Tooltip id="button-tooltip">
                             {t("inbox_page.delete_selected_messages")}
                          </Tooltip>
                       }
                   >
                      <MdDelete
                          size={24}
                          onClick={async () => {
                             for (const id of selectedNotifications) {
                                await hideRecipient(id);
                             }

                             let notifications = await getMessages();
                             setNotifications(notifications);
                          }}
                          className={"icon mr-2"}
                      />
                   </OverlayTrigger>
               }

               {!loading &&
                   <OverlayTrigger
                       placement={'bottom'}
                       delay={{show: 250, hide: 400}}
                       overlay={
                          <Tooltip id="button-tooltip">
                             {t("inbox_page.sent")}
                          </Tooltip>
                       }
                   >
                      <MdSend
                          size={24}
                          onClick={() => {
                             history.push('/notifications/sent')
                          }}
                          className={"icon mr-2"}
                      />
                   </OverlayTrigger>
               }

               {!loading &&
                   <OverlayTrigger
                       placement={'bottom'}
                       delay={{show: 250, hide: 400}}
                       overlay={
                          <Tooltip id="button-tooltip">
                             {t("inbox_page.new_message")}
                          </Tooltip>
                       }
                   >
                      <MdCreate
                          size={24}
                          onClick={() => {
                             history.push('/notifications/new')
                          }}
                          className={"icon"}
                      />
                   </OverlayTrigger>
               }
            </Col>
         </Row>

         {notifications.map((notification, key) => {
            const div = document.createElement('div');
            div.innerHTML = notification.body;

            return (
                <Row key={key}>
                   <Col xs={12}>
                      <Notification
                          id={notification.id}
                          title={notification.title}
                          date={moment(notification.date).utc().format('DD/MM/YYYY')}
                          body={`${div.innerText.substring(0, 150)}...`}
                          read={notification.read}
                          archived={notification.archived}
                          onClick={() => history.push(`/notifications/${notification.id}`, {from: history.location.pathname})}
                          onChangeCheckBox={(e) => {
                             if (e.target.checked) {
                                setselectedNotifications([...selectedNotifications, parseInt(e.target.value)])
                             } else {
                                setselectedNotifications(selectedNotifications.filter((id) => id !== parseInt(e.target.value)))
                             }
                          }}
                          checkboxChecked={selectedNotifications.includes(notification.id)}
                      />
                   </Col>
                </Row>
            );
         })}
      </Container>
   </div>
}

export default NotificationList;
